import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { FileTypeRuleComponent } from './FileTypeRuleComponent';

const configValidator = yup
  .object({
    value: yup.array().notRequired().label('Formati file ammessi'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRuleFileType = yup.InferType<typeof configValidator>;

export const FileTypeRule: IRuleType<IRuleFileType> = {
  type: RuleType.FileType,
  name: 'Formati file ammessi',
  configComponent: FileTypeRuleComponent,
  configValidator: configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    return schema.test({
      name: 'file-type',
      exclusive: false,
      params: { value: rule.value },
      test: function (value, context) {
        return true;
      },
    });
  },
};
